import { Injectable } from '@angular/core';
import { WindowService } from '@services/window/window.service';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  private sessionStorage: Storage = WindowService.sessionStorage;

  // Get an item from session storage
  getItem<T>(key: string): T | null {
    try {
      const item = this.sessionStorage.getItem(key);
      return item ? JSON.parse(item) as T : null;
    } catch (error) {
      console.error(`Error getting item with key "${key}":`, error);
      return null;
    }
  }

  // Set an item in session storage
  setItem<T>(key: string, value: T): void {
    try {
      const item = JSON.stringify(value);
      this.sessionStorage.setItem(key, item);
    } catch (error) {
      console.error(`Error setting item with key "${key}":`, error);
    }
  }

  // Remove an item from session storage
  removeItem(key: string): void {
    try {
      this.sessionStorage.removeItem(key);
    } catch (error) {
      console.error(`Error removing item with key "${key}":`, error);
    }
  }
}
